export default __webpack_public_path__ + "static/media/chemistry-glassware-56a12a083df78cf772680235.c59c1cca.jpg";